<template>
  <el-dialog
    :title="$t('addSysDocumentView.title')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('addSysDocumentView.docTitle')" prop="docTitle">
        <el-input
          v-model="form.docTitle"
          :placeholder="$t('addSysDocumentView.docTitlePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('addSysDocumentView.docCode')" prop="docCode">
        <el-input
          v-model="form.docCode"
          :placeholder="$t('addSysDocumentView.docCodePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('addSysDocumentView.docContent')" prop="docContent">
        <el-input
          type="textarea"
          :rows="10"
          v-model="form.docContent"
          :placeholder="$t('addSysDocumentView.docContentPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('addSysDocumentView.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('addSysDocumentView.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveSysDocument } from '@/api/dev/sysDocument/sysDocumentApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddSysDocumentView',
  data() {
    return {
      dialogVisible: false,
      form: {
        docTitle: '',
        docCode: '',
        docContent: '',
        shopId: ''
      },
      rules: {
        docTitle: [
          { required: true, message: this.$t('addSysDocumentView.docTitleRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('addSysDocumentView.docTitleMaxLength'), trigger: 'blur' }
        ],
        docCode: [
          { required: true, message: this.$t('addSysDocumentView.docCodeRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('addSysDocumentView.docCodeMaxLength'), trigger: 'blur' }
        ],
        docContent: [
          { required: true, message: this.$t('addSysDocumentView.docContentRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.form.shopId = getShopId()
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.$emit('close')
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveSysDocument(this.form)
            this.$message.success(this.$t('addSysDocumentView.saveSuccess'))
            this.handleClose()
          } catch (error) {
            console.error('保存文档失败:', error)
          }
        }
      })
    }
  }
}
</script>